import type { Archive } from "../domain/types";
import { finishPendingTurn, listRecoverableTurns } from "./db";
import { applyPostTurn } from "./sendMessage/postTurn";

export interface PendingTurnRecoveryResult {
  archive: Archive;
  notices: string[];
}

export async function recoverPendingTurns(archive: Archive): Promise<PendingTurnRecoveryResult> {
  const rows = await listRecoverableTurns(archive.name);
  let recovered = structuredClone(archive);
  const notices: string[] = [];
  for (const row of rows) {
    const committed = recovered.messages.some((message) => message.turnId === row.id);
    if (!committed && row.assistantText && ["main-complete", "committing", "settling", "evolving", "complete"].includes(row.phase)) {
      recovered = applyPostTurn(recovered, row.input, row.assistantText, { turnId: row.id }).archive;
      notices.push("已恢复崩溃前完成的主叙事；未自动重跑可能产生额外费用的后置请求。");
    } else if (committed && row.phase !== "complete") {
      notices.push("上次主叙事已经保存；未完成的可选结算已停止，未重复执行。");
    } else if (!committed && row.phase !== "complete") {
      notices.push("已清理上次未完成且没有完整正文的请求，可由你决定是否重试。");
    }
    await finishPendingTurn(row.id);
  }
  return { archive: recovered, notices: [...new Set(notices)] };
}
